// DataContext.js
import React, { useState } from "react";
import { createContext, useContext } from "react";
import { useSetState } from "../../hooks";

const DataContext = createContext({});
export interface DataContextProps {
  contextData: any;
  setContextData: (d: any) => void;
}

export const DataProvider = ({ children }: { children: React.ReactNode | React.ReactNode[] }) => {
  // 这里定义需要共享的数据
  const [contextData, setContextData] = useSetState<any>({
    addressName: "",
    selectAddress: {}
  });

  return (
    <DataContext.Provider
      value={{ contextData, setContextData }}
    >
      {children}
    </DataContext.Provider>
  );
};

export const useContextData = () => useContext(DataContext) as DataContextProps;
